import React,{ Component } from 'react';
import ArticleEditContainer from './container/ArticleEditContainer';

export default class ArticleEdit extends Component{
    componentDidMount() {
        window.scrollTo(0,0)
    }
    render(){

        return(
            <React.Fragment>
                <ArticleEditContainer {...this.props} />
            </React.Fragment>

        )
    }
}
